(function(){
  function markPrices() {
    // Taranacak olası seçiciler (temalara göre geniş tuttuk)
    var selectors = [
      '.price', '.price-item--regular', '.product-card__price', '.product__price',
      '.price--regular', '.price-regular', '.product-grid-item__price', '.money',
      '[data-price]', 'span[itemprop="price"]'
    ];
    var seen = new Set();

    selectors.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){
        // Aynı elementi tekrar işlememek için kontrol
        if(seen.has(el)) return;
        seen.add(el);

        // boş içerik atla
        if(!el.textContent.trim()) return;

        // Eğer içinde <s> veya <del> varsa eski fiyat olarak kabul et
        var hasStrikeTag = !!el.querySelector('s, del');

        // Computed style'dan üstü çizili kontrolü
        var st = window.getComputedStyle(el);
        var hasLineThrough = st && st.textDecorationLine && st.textDecorationLine.indexOf('line-through') !== -1;

        // Bazı temalarda üstü çizili fiyat farklı bir sibling/parent içinde olabilir:
        if(!hasStrikeTag) {
          // ebeveyninde s/del arama
          if(el.closest && el.closest('.price') && el.closest('.price').querySelector('s,del')) {
            hasStrikeTag = true;
          }
        }

        // Eğer üstü çizili değilse, kırmızı sınıf ekle
        if(!hasStrikeTag && !hasLineThrough) {
          el.classList.add('wch-price-red');
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    markPrices();
    // Dinamik yüklense bile yakalayalım
    var obs = new MutationObserver(function(){ markPrices(); });
    obs.observe(document.body, {childList: true, subtree: true});
  });
})();
